module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading_with_sub/heading_with_sub_6-a34639fcbe747c6040f69b155e713365.png";